package org.mkui.canvas

import org.mkui.color.MkColor
import org.mkui.geom.Rectangle
import org.mkui.graphics.IDrawing
import web.canvas.CanvasRenderingContext2D

class ElementalDirectGWTLayer : CanvasRenderingContext2DLayer {
    private val iDrawing: IDrawing
    private var paletteProvider: PaletteProvider? = null
    private var width = 0.0
    private var height = 0.0

    constructor(iDrawing: IDrawing) {
        this.iDrawing = iDrawing
    }

    constructor(iDrawing: IDrawing, paletteProvider: PaletteProvider?) {
        this.iDrawing = iDrawing
        this.paletteProvider = paletteProvider
    }

    override fun prepare(width: Int, height: Int) {
        this.width = width.toDouble()
        this.height = height.toDouble()
    }

    override fun render(g: CanvasRenderingContext2D) {
        if (iDrawing.isActive) {
            draw(g, iDrawing, width, height, paletteProvider, null, null)
        }
    }

    val drawing: IDrawing
        get() = iDrawing

    companion object {
        fun draw(
            g2: CanvasRenderingContext2D,
            iDrawing: IDrawing,
            width: Double,
            height: Double,
            paletteProvider: PaletteProvider?,
            color: MkColor?,
            composite: Double?
        ) {
            var color: MkColor? = color
            val globalAlpha: Double = g2.globalAlpha

//        Color oldColor = g2.getColor();
            if (paletteProvider != null) {
                val start: MkColor = paletteProvider.palette.getColor(0.0)
                val end: MkColor = paletteProvider.palette.getColor(1.0)
                val s: Float = start.getRed().toFloat() / 255f
                val e: Float = end.getRed().toFloat() / 255f
                if (e > s) {
                    color = end
                    if (composite == null) {
                        val alpha = s / e
                        g2.globalAlpha = alpha.toDouble()
                    }
                } else {
                    color = end
                    if (composite == null) {
                        val alpha = (1f - s) / (1f - e)
                        g2.globalAlpha = alpha.toDouble()
                    }
                }
            }
            if (color != null) {
                val javaScriptColor: String = color.toJavaScriptColor()
                g2.fillStyle = javaScriptColor
                g2.strokeStyle = javaScriptColor
            }
            if (composite != null) {
                g2.globalAlpha = composite
            }
            iDrawing.draw(ElementalIGraphics(g2), null, width, height, Rectangle(0, 0, width.toInt(), height.toInt()))

//        g2.setColor(oldColor);
            g2.globalAlpha = globalAlpha
        }
    }
}
